import React, { useEffect, useState } from "react";

import label from "../../labels/administration_en.json";

import VigatvariReport from "../../../interviewProcess/components/cutOff/vigatvariReport";

const Recommandation = () => {

  const [stepName, setName] = useState("vigatvari");


  return (
    <div className="commonContentArea">
      <h5 className="labelMargin"> {label.Recommandation} </h5>
      <div
        className="tab-content border border-light myTabContent"
        id="myTabContentContainer"
      >
        <ul className="nav nav-tabs" id="myTab" role="tablist">

          <li className="nav-item" key="1">
            <a
              href="#"
              className={
                stepName === "vigatvari"
                  ? "nav-link active"
                  : "nav-link bg-profile-tabs"
              }
              value="vigatvari"
              id="vigatvari-tab"
              onClick={() => setName("vigatvari")}
              data-toggle="tab"
              role="tab"
              aria-controls="vigatvari"
              aria-selected="false"
            >
              <span>Vigatvari Report</span>
            </a>
          </li>

        </ul>


        <div className="tab-content border border-light" id="myTabContent">

          <div
            className={
              stepName === "vigatvari"
                ? "tab-pane fade show active"
                : "tab-pane fade styled-tab"
            }
            id="vigatvari"
            role="tabpanel"
            aria-labelledby="vigatvari-tab"
          >
            <div className="row dashboardCards">
              <div className="col-md-12">
                <VigatvariReport key={stepName} />
              </div>
            </div>
          </div>

        </div>

      </div>
    </div>
  );
}

export default Recommandation;